<template>
<div>
  <gmap-map ref='mapRef' :center="center" :zoom="zoom" :options="options" style="width:100vw;  height: 100vh; z-index: 0">
    <gmap-marker :key="index" v-for="(m, index) in markers" :position="m.position" :icon="m.icon" :visible='m.visible' @click="targetMarker(m)"></gmap-marker>
  </gmap-map>
</div>
</template>

<script>
import catalog from '@/assets/pins.json';
import {
  EventBus
} from '@/eventBus.js';
import Vue from 'vue';

const projectStartDate = new Date('April 7, 2019');
const currentDate = new Date();

const initZoom = 15;

export default {
  name: "GoogleMap",
  data() {
    return {
      center: {
        lat: 37.0013,
        lng: -122.0615
      },
      zoom: initZoom,
      markers: [],
      places: [],
      currentPlace: null,
      dateRange: [projectStartDate, currentDate],
      timeRange: [0, 24 * 60],
      options: {
        mapTypeId: "satellite",
        streetViewControl: false,
        mapTypeControl: false,
        disableDefaultUi: true,
        fullscreenControl: false,
        zoomControl: false,
        zoomControlOptions: {
          position: 6
        },
        currentZoom: initZoom,
      },

    };
  },

  mounted() {
    import('@/assets/weather.json').then(weather => {
      this.addMarkers(weather)
    });
    this.mics = ['H3-VR', 'NT-SF1'];
    this.dayIndexes = [0, 1, 2, 3, 4, 5, 6];
    EventBus.$on('timeRange', this.updateTimeRange);
    EventBus.$on('zoom', this.setZoom);
    EventBus.$on('days', this.updateDays);
    EventBus.$on('mics', this.updateMics);
    EventBus.$on('dateRange', this.updateDateRange);
  },

  methods: {

    updateDateRange(dateRange) {
      this.dateRange = [new Date(dateRange[0]), new Date(dateRange[1])];
      this.filterMarkers();
    },

    updateTimeRange(timeRange) {
      this.timeRange = timeRange;
      this.filterMarkers();
    },

    updateDays(dayArray) {
      const days = ['Su', 'M', 'T', 'W', 'Th', 'F', 'Sa'];
      this.dayIndexes = Array.from(dayArray, day => days.indexOf(day));
      this.filterMarkers();
    },

    updateMics(micArray) {
      this.mics = micArray;
      this.filterMarkers();
    },

    filterMarkers() {
      this.markers.forEach(marker => {
        const test1 = this.testDate(marker);
        const test2 = this.testDateRange(marker);
        const test3 = this.testTimeRange(marker);
        const test4 = this.testMic(marker);
        Vue.set(marker, 'visible', test1 && test2 && test3 && test4)
      })
    },

    testTimeRange(marker) {
      let time = marker.position.time.slice(0, -3).split(':');
      time = Number(time[0]) * 60 + Number(time[1]);
      const test1 = time >= this.timeRange[0];
      const test2 = time <= this.timeRange[1];
      return test1 && test2;


    },

    testDateRange(marker) {
      const markerDate = new Date(marker.position.date);
      const test1 = markerDate.getTime() >= this.dateRange[0].getTime();
      const test2 = markerDate.getTime() <= this.dateRange[1].getTime();
      return test1 && test2;
    },

    testDate(marker) {
      const date = new Date(marker.position.date);
      const dayIndex = date.getDay();
      return this.dayIndexes.includes(dayIndex);
    },

    testMic(marker) {
      const mic = marker.mic;
      return this.mics.includes(mic);

    },

    setZoom(zoomChange) {
      this.$refs.mapRef.$mapPromise.then(map => {
        map.setZoom(map.getZoom() + zoomChange);
      })
    },

    targetMarker(m) {
      this.$refs.mapRef.$mapPromise.then(map => {
        map.panTo(m.position)
      });
      EventBus.$emit('marker', m);

    },
    // receives a place object via the autocomplete component
    setPlace(place) {
      this.currentPlace = place;
    },

    addMarkers(weather) {

      for (let i = 0; i < catalog.length; i++) {
        const marker = {
          lat: Number(catalog[i].latitude),
          lng: Number(catalog[i].longitude),
          catNum: Number(catalog[i].catalog_number),
          time: catalog[i].start_time,
          date: catalog[i].date,
          heading: catalog[i].orientation,
          colloquialism: catalog[i].colloquial_location,
          temp: {
            summary: weather[i + 1].summary,
            temperature: weather[i + 1].temperature,
          }
        };
        const iconUrl = catalog[i].recorder_number === 'H3-VR' ?
        "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png" :
        "http://maps.google.com/mapfiles/ms/icons/blue-dot.png";
        this.markers.push({
          position: marker,
          icon: iconUrl,
          mic: catalog[i].recorder_number
        });
      }
    },
  }
};
</script>
